import type { Resource } from '../../';
export const language_jp: Resource = {"default":"Japanese"};
